import ls from "../services/localStorage";
import { types } from "../constants/constants";

export const getApiTranslations = (attributes : any): Promise<object> => {
  const esc = encodeURIComponent;
  const query = Object.keys(attributes) ? '?' + Object.keys(attributes).map(k => `${esc(k)}=${esc(attributes[k])}`).join('&') : ''
  const token:(string | null) = ls.get("token");
  
  return fetch(`${types.API_URL}translations${query}`, { 
    headers : { token : ( token !== null ? token : '') } 
  }).then(async (response) => {
    if(!response.ok){
      const responseJson = await response.json()
      throw new Error(responseJson)
    }
    const result: object = await response.json()

    return { translations : result };
  })
};

export const postApiCreateTranslation = (attributes: any) => {
  const token:(string | null) = ls.get("token");

  return fetch(`${types.API_URL}/translation/create`, {
    method: "POST",
    headers: {
      token : ( token !== null ? token : ''),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(attributes),
  }).then(async (response) => {
    if(!response.ok){
      const responseJson = await response.json()
      throw new Error(responseJson)
    }
    return response.json()
  }); 
};

export const putApiUpdateTranslation = (attributes: any) => {
  const token:(string | null) = ls.get("token");
  
  console.log(JSON.stringify({ translation : attributes }))

  return fetch(`${types.API_URL}translations/update/${attributes.key}`, {
    method: "PUT",
    headers: {
      token : ( token !== null ? token : ''),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ translation : attributes }),
  }).then(async (response) => {
    if(!response.ok){
      const responseJson = await response.json()
      throw new Error(responseJson)
    }
    return response.json()
  }); 
};